var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import { memo, useMemo } from 'react';
import { FactoryContent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { ContentContainer } from '../../templates/ContentContainer';
var rowsData = function (row, rowIndex, cellsDesign, overwriteDesign, conditionalDesign, tableData, allGlobalData, isBody) {
    var rowDesign = row[0], rowConfig = row[1];
    var rowDesignOverwritten = (overwriteDesign === null || overwriteDesign === void 0 ? void 0 : overwriteDesign["[".concat(rowIndex, "]")]) || rowDesign;
    var rowDesignConditional = (conditionalDesign === null || conditionalDesign === void 0 ? void 0 : conditionalDesign["[".concat(rowIndex, "]")]) || (conditionalDesign === null || conditionalDesign === void 0 ? void 0 : conditionalDesign['[*]']) || null;
    var hasConditionalDesign = !!rowDesignConditional && !!(rowDesignConditional === null || rowDesignConditional === void 0 ? void 0 : rowDesignConditional.condition) && !!(rowDesignConditional === null || rowDesignConditional === void 0 ? void 0 : rowDesignConditional.design);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var evalData = {
        tableData: tableData,
        rowData: tableData === null || tableData === void 0 ? void 0 : tableData[rowIndex],
        rowIndex: rowIndex,
    };
    var useConditionalDesign = hasConditionalDesign
        ? // eslint-disable-next-line no-eval
            eval("".concat(rowDesignConditional.condition, "(evalData)"))
        : false;
    var conditionalResult = useConditionalDesign
        ? rowDesignConditional.design
        : (rowDesignConditional === null || rowDesignConditional === void 0 ? void 0 : rowDesignConditional.default) || rowDesignOverwritten;
    return [
        'TableRow',
        isBody ? (hasConditionalDesign ? conditionalResult : rowDesignOverwritten) : rowDesign,
        __assign({ rowIndex: rowIndex, rowData: (tableData === null || tableData === void 0 ? void 0 : tableData[rowIndex]) || {}, tableData: tableData, globalData: allGlobalData, cellsDesign: cellsDesign, overwriteDesign: overwriteDesign, conditionalDesign: conditionalDesign, isBody: isBody }, rowConfig),
    ];
};
var extractPathFromSources = function (path) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var found = sources.find(function (source) { return !!get(source, path); });
    return found ? get(found, path) : null;
};
export var Table = memo(function (_a) {
    var design = _a.design, data = _a.data, values = _a.values, globalDataSource = _a.globalDataSource, globalData = _a.globalData, rest = __rest(_a, ["design", "data", "values", "globalDataSource", "globalData"]);
    var _b = useDesign((rest === null || rest === void 0 ? void 0 : rest['data-design']) || design), config = _b.config, components = _b.components, schema = _b.schema;
    var schemaWrapper = useDesign(components.wrapper).schema;
    var _c = config || {}, _d = _c.rowsDesign, rowsDesign = _d === void 0 ? '' : _d, _e = _c.cellsDesign, cellsDesign = _e === void 0 ? '' : _e, _f = _c.overwriteDesign, overwriteDesign = _f === void 0 ? {} : _f, _g = _c.targetSource, targetSource = _g === void 0 ? rest.targetSource : _g, _h = _c.conditionalDesign, conditionalDesign = _h === void 0 ? {} : _h, _j = _c.displayQueries, displayQueries = _j === void 0 ? {} : _j;
    var usableSource = extractPathFromSources(targetSource, values, data, globalData, rest);
    var _usableData = usableSource || values || data;
    var usableData = Array.isArray(_usableData) ? _usableData : [];
    var globalDataSourceConfig = get(values, config.globalDataSource, {});
    var globalDataSourceProps = get(values, globalDataSource, {});
    var allGlobalData = __assign(__assign(__assign({}, globalDataSourceConfig), globalDataSourceProps), (globalData || {}));
    var allRows = useMemo(function () {
        var _a, _b, _c;
        var commonParams = [
            cellsDesign,
            overwriteDesign,
            conditionalDesign,
            usableData,
            allGlobalData,
        ];
        return {
            bodyDataRows: (usableData === null || usableData === void 0 ? void 0 : usableData.map(function (row, rowIndex) {
                return rowsData.apply(void 0, __spreadArray(__spreadArray([[rowsDesign], rowIndex], commonParams, false), [true], false));
            })) || [],
            bodyRows: ((_a = config.bodyRows) === null || _a === void 0 ? void 0 : _a.map(function (row, rowIndex) { return rowsData.apply(void 0, __spreadArray([row, rowIndex], commonParams, false)); })) || [],
            headerRows: ((_b = config.headerRows) === null || _b === void 0 ? void 0 : _b.map(function (row, rowIndex) { return rowsData.apply(void 0, __spreadArray([row, rowIndex], commonParams, false)); })) || [],
            footerRows: ((_c = config.footerRows) === null || _c === void 0 ? void 0 : _c.map(function (row, rowIndex) { return rowsData.apply(void 0, __spreadArray([row, rowIndex], commonParams, false)); })) || [],
        };
    }, [
        usableData,
        _usableData,
        config.headerRows,
        config.bodyRows,
        config.footerRows,
        config.targetSource,
        config.wrapper,
        allGlobalData,
    ]);
    var bodyDataRows = allRows.bodyDataRows, bodyRows = allRows.bodyRows, headerRows = allRows.headerRows, footerRows = allRows.footerRows;
    var content = (_jsxs(GenericComponent, __assign({ schema: schema, as: "table", design: design }, { children: [config.headerRows && (_jsx("thead", { children: _jsx(FactoryContent, { config: { content: headerRows }, autoIndex: true }) })), (!!bodyDataRows.length || !!bodyRows.length) && (_jsx("tbody", { children: _jsx(FactoryContent, { config: { content: bodyDataRows.length ? bodyDataRows : bodyRows, displayQueries: displayQueries }, autoIndex: true, values: __assign({ globalData: allGlobalData }, allGlobalData) }) })), components.tBody && _jsx(ContentContainer, { as: "tbody", design: components.tBody }), config.footerRows && (_jsx("tfoot", { children: _jsx(FactoryContent, { config: { content: footerRows }, autoIndex: true }) }))] })));
    if (components.wrapper) {
        return (_jsx(GenericComponent, __assign({ as: "div", schema: schemaWrapper, design: components.wrapper }, { children: content })));
    }
    return content;
});
Table.displayName = 'Table';
